var React = require('react');

function Chalkboard (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M624 448h-16V40a40 40 0 0 0-40-40H72a40 40 0 0 0-40 40v408H16a16 16 0 0 0-16 16v32a16 16 0 0 0 16 16h608a16 16 0 0 0 16-16v-32a16 16 0 0 0-16-16zm-528 0V64h448v384z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M544 64v384h-64v-64H288v64H96V64z","className":"fa-primary","key":2})]);
}

Chalkboard.defaultProps = {"viewBox":"0 0 640 512","className":"icon"};

module.exports = Chalkboard;

Chalkboard.default = Chalkboard;
